<template>
  <div class="logins-wrapper">
    <div class="wrapper">
      <img @click='goBack' class="goback" src="../../../static/images/goback.png" alt="">
      <p class="psd_guid">密码登录</p>
      <div class="box right">
        <div class="name">
          <input placeholder="手机号" type="number" name="user_name" id="tel" v-model='user_name' @keyup='checkIfCanLogin'>
        </div>
        <div class="pass">
          <input placeholder="密码" type="password" name="password" id="pass" v-model='user_psd' @keyup='checkIfCanLogin'>
        </div>
        <div class="r-bot">
          <button class="login" id="login" :disabled='disabledFlag' @click='login' :class="{disabled:disabledFlag}">登录
          </button>
          <p class="usual_problem"><span @click="code_login">验证码登录/注册</span>
            <!-- <span @click='reset_psd' class="reset_psd">忘记密码？</span> -->
          </p>
        </div>
      </div>
      <p class="agreement">登录即代表同意
        <a href="http://www.eoffcn.com/help/agreements/offcnapp_user_agreement.html" class="error_msg">《用户协议》</a>和
        <a href="http://www.eoffcn.com/help/agreements/offcnapp_privacy_policy.html" class="error_msg">《隐私政策》</a>
      </p>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'vant'

  export default {
    data () {
      return {
        user_name: '',
        user_psd: '',
        disabledFlag: true,
        ticketObj: {}
      }
    },
    mounted () {
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      // 检测是否可登录
      checkIfCanLogin () {
        if ($('#tel').val().length > 0 && $('#pass').val().length > 0) {
          this.disabledFlag = false
        } else {
          this.disabledFlag = true
        }
      },
      // 登录
      login () {
        this.$api.LOGIN({
          username: this.user_name,
          password: this.user_psd
        }).then(res => {
          if (res.code == 0) {
            this.ticketObj = {
              'offcn-ticket': res.data.ticket,
              ticket_source: res.data.ticket_source,
              sso_id: res.data.sso_user_id,
              name: res.data.user_info.name,
              phone: res.data.user_info.username
            }
            console.log('444444444444'+this.ticketObj)
            window.localStorage.setItem('ticketObj', JSON.stringify(this.ticketObj))
            this.$router.push({path: 'index'})
            var that = this
            $.ajax({
              url: (process.env.NODE_ENV=='production' ? '//shop.eoffcn.com': '//shop.t.eoffcn.com') + '/api/user/get_sign?phone=' + JSON.parse(localStorage.getItem("ticketObj")).phone,
              type: 'get',
              success: function (res) {
                if (res.status == 0) {
                  that.ticketObj.sign = res.data.sign
                  window.localStorage.setItem('ticketObj', JSON.stringify(that.ticketObj))
                }
              }
            })
          } else {
            Toast('输入正确手机号和密码')
          }
        })
      },
      code_login () {
        this.$router.push({path: '/'})
      },
      reset_psd () {
        this.$router.push({path: 'reset'})
      }
    }
  }
</script>

<style lang="less" scoped>
  .logins-wrapper {
    height: 100%;
    background: #ffffff;
    .wrapper {
      padding: 60px;
      height: 100%;
      background: url(./static/images/login_bg.jpg) no-repeat top center;
      background-size: cover;
      .goback {
        width: 12px;
        height: 28px;
      }
      .psd_guid {
        font-size: 42px;
        font-weight: bold;
        margin-top: 100px;
      }
    }
    .agreement {
      text-align: center;
      margin-top: 274px;
    }
    .error_msg {
      color: #e60012;
    }
  }

  .box {
    margin-top: 120px;
    .name, .pass {
      position: relative;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #cccccc;
      input {
        width: 100%;
        height: 90px;
        outline: none;
        font-size: 28px;
        position: relative;
        border: none;
        background: transparent;
      }
    }
    .pass {
      margin-top: 15px;
    }
    .r-bot {
      margin-top: 60px;
      .login {
        width: 100%;
        height: 100px;
        border: none;
        color: #ffffff;
        font-size: 36px;
        background: #e60012;
        border-radius: 50px;
        &.disabled {
          background: #e89692;
        }
      }
      .usual_problem {
        color: #666666;
        font-size: 26px;
        margin-top: 50px;
        .reset_psd {
          float: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/login.vue